import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-182">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-gradient-to-br from-navy-800 to-navy-900 border border-navy-600 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-183">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-400 to-transparent opacity-50" data-id="element-184"></div>

        <div className="inline-flex items-center justify-center p-4 bg-navy-900 rounded-full mb-6 border border-navy-700 shadow-lg" data-id="element-185">
          <ShieldCheck className="w-12 h-12 text-gold-400" data-id="element-186" />
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-187">
          🛡️ GARANTÍA MUNDORECURSOS™ — 7 DÍAS
        </h2>

        <div className="space-y-4 text-lg text-blue-100 max-w-2xl mx-auto mb-8" data-id="element-188">
          <p data-id="element-189">
            Abrís los 6 tomos. Revisás los 6 bonos. Los aplicás con tu perro si
            querés.
          </p>
          <p data-id="element-190">Si en 7 días no es lo que esperabas:</p>
          <p className="text-xl font-bold text-white bg-navy-900/50 py-3 px-6 rounded-xl inline-block border border-navy-700" data-id="element-191">
            Te devolvemos el 100%.
            <br data-id="element-192" />
            <span className="text-base font-normal text-blue-200" data-id="element-193">
              Sin preguntas. Sin formularios. Sin drama.
            </span>
          </p>
          <p className="text-base" data-id="element-194">
            La confianza que tenemos en la Guía Del Perro Tranquilo nos permite
            hacer esa promesa sin dudar. Más de 500 dueños de todo el país ya lo
            saben.
          </p>
        </div>

        <div className="inline-block bg-green-900/30 text-green-400 border border-green-800/50 px-4 py-2 rounded-full text-sm font-medium" data-id="element-195">
          La tasa de devoluciones es menor al 1%.
        </div>
      </motion.div>
    </section>;
}